var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0007 6.66602C25.2731 6.66602 13.334 18.8189 13.334 33.8103C13.334 48.6842 21.8451 66.0407 35.1242 72.2475C38.2198 73.6944 41.7815 73.6944 44.8771 72.2475C58.1562 66.0407 66.6673 48.6842 66.6673 33.8103C66.6673 18.8189 54.7282 6.66602 40.0007 6.66602ZM27.5007 33.3327C27.5007 26.4291 33.0971 20.8327 40.0007 20.8327C46.9042 20.8327 52.5006 26.4291 52.5006 33.3327C52.5006 35.8754 51.7396 38.243 50.4353 40.2169L53.4396 43.2377C54.4132 44.2167 54.4089 45.7996 53.4299 46.7733C52.4509 47.7469 50.868 47.7425 49.8943 46.7635L46.9028 43.7555C44.9253 45.067 42.5511 45.8327 40.0007 45.8327C33.0971 45.8327 27.5007 40.2362 27.5007 33.3327ZM32.5007 33.3327C32.5007 29.1905 35.8585 25.8327 40.0007 25.8327C44.1428 25.8327 47.5006 29.1905 47.5006 33.3327C47.5006 35.4 46.6675 37.2679 45.3128 38.6271C43.9521 39.9923 42.0769 40.8327 40.0007 40.8327C35.8585 40.8327 32.5007 37.4748 32.5007 33.3327Z",
    fill: "#DC143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellIcon2);
export default __webpack_public_path__ + "static/media/sell-icon-2.c028a9dfc6d0ef7fa8e9c789ac17b84c.svg";
export { ForwardRef as ReactComponent };